import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Link, useNavigate } from "react-router-dom";

const ServicesPage = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      {/* About Section */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                <h1 className="mb-0">
                  Empowering Businesses with Tax, Finance, Marketing & HR
                  Solutions
                </h1>
              </div>
              <p className="mb-4">
                At My Easy Tax Pro Partners, we provide end-to-end business
                solutions — from taxation and loan assistance to digital
                marketing and recruitment support. Our goal is to help
                individuals and enterprises manage finances, grow visibility,
                and build strong teams under one trusted platform.
              </p>
              <p className="mb-4">
                From lead generation to sales conversion, we focus on driving
                measurable growth that strengthens your brand and boosts
                revenue. At My Easy Tax Pro Partners, our expert team combines
                digital marketing intelligence, data-driven strategies, and
                proven sales techniques to help your business attract the right
                audience, convert potential leads, and achieve sustainable
                success in today’s competitive market.
              </p>
            </div>

            <div className="col-lg-5" style={{ minHeight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src="assets/img/service.png"
                  alt="About My Easy Tax"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Spacing (optimized for all devices) */}
      <div className="my-5"></div>

      {/* Services Section */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">
              Our Services
            </h5>
            <h1 className="mb-0">Comprehensive Business Solutions for Growth</h1>
          </div>

          <div className="row g-5">
            {/* TAXATION */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center p-4"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/services/taxation")}
              >
                <div className="service-icon mb-3">
                  <i className="fa fa-file-invoice-dollar text-white"></i>
                </div>
                <h4 className="mb-3">Taxation</h4>
                <p className="m-0">
                  Simplify your finances with our expert tax services — from GST
                  to ITR, we ensure accuracy, compliance, and maximum savings
                  for your business.
                </p>

                <Link
                  to="/services/taxation"
                  className="btn btn-lg btn-primary rounded mt-3"
                >
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* LOANS */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center p-4"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/services/loans")}
              >
                <div className="service-icon mb-3">
                  <i className="fa fa-hand-holding-usd text-white"></i>
                </div>
                <h4 className="mb-3">Loans</h4>
                <p className="m-0">
                  Get quick and reliable access to funding with our wide range
                  of loan solutions designed to support startups, SMEs, and
                  growing enterprises.
                </p>

                <Link
                  to="/services/loans"
                  className="btn btn-lg btn-primary rounded mt-3"
                >
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* DIGITAL MARKETING */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center p-4"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/services/digital")}
              >
                <div className="service-icon mb-3">
                  <i className="fa fa-bullhorn text-white"></i>
                </div>
                <h4 className="mb-3">Digital Marketing</h4>
                <p className="m-0">
                  Boost your brand visibility and online presence with our
                  result-driven digital marketing strategies tailored to convert
                  leads into loyal customers.
                </p>

                <Link
                  to="/services/digital"
                  className="btn btn-lg btn-primary rounded mt-3"
                >
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* RECRUITMENT */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div
                className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center p-4"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/services/recruitment")}
              >
                <div className="service-icon mb-3">
                  <i className="fa fa-user-tie text-white"></i>
                </div>
                <h4 className="mb-3">Recruiting & Staffing</h4>
                <p className="m-0">
                  Build a strong and efficient team with our professional
                  recruitment and staffing solutions that connect the right
                  talent with the right opportunities.
                </p>

                <Link
                  to="/services/recruitment"
                  className="btn btn-lg btn-primary rounded mt-3"
                >
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* PARTNER WITH US */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                <h3 className="text-white mb-3">Partner With Us</h3>
                <p className="text-white mb-3">
                  Collaborate with My Easy Tax Pro Partners and unlock access to
                  proven systems for growth, leads, and long-term business
                  success.
                </p>
                <h2 className="text-white mb-0">Grow With Us</h2>
              </div>
            </div>

            {/* CALL US */}
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
              <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                <h3 className="text-white mb-3">Call Us For Quote</h3>
                <p className="text-white mb-3">
                  Have questions or need assistance? Our experts are here to
                  guide you toward smarter financial and business solutions.
                </p>
                <h2 className="text-white mb-0">+91 98765 43210</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Vendors Slider */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5 mb-5">
          <div className="bg-white">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={5}
              loop={true}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: { slidesPerView: 2 },
                640: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
              }}
            >
              {[
                "mel.png",
                "jby.png",
                "dw.png",
                "meo.png",
                "met.png",
                
              ].map((img, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={`assets/img/${img}`}
                    alt={`Vendor ${i + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      filter: "grayscale(100%)",
                      transition: "filter 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.filter = "grayscale(0%)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.filter = "grayscale(100%)")
                    }
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
